// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import CheckCircleFilledSvg from "@ant-design/icons-svg/lib/asn/CheckCircleFilled";
import AntdIcon from "../components/AntdIcon";
const CheckCircleFilled = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: CheckCircleFilledSvg
    });
if (process.env.NODE_ENV !== "production") {
    CheckCircleFilled.displayName = "CheckCircleFilled";
}
export default /*#__PURE__*/ React.forwardRef(CheckCircleFilled);
